let $svg_pgut_pattern_group_before = '<svg preserveAspectRation="none" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1920 36.9511L1920 40.9998L-9.20067e-07 40.9998L-8.27239e-07 36.8632C253.87 13.9509 590.37 7.18359e-07 959.5 7.18359e-07C1329.12 -0.00365998 1666.01 13.9839 1920 36.9511Z" fill="currentColor"/> </svg>';
let $svg_pgut_pattern_group_after = '<svg preserveAspectRation="none" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M-2.40116e-06 4.04894L-2.66425e-06 0.000212198L1920 4.43459e-05L1920 4.13664C1666.13 27.049 1329.63 40.9999 960.5 41C590.88 41.0037 253.99 27.0162 -2.40116e-06 4.04894Z" fill="currentColor"/> </svg>';


// jQuery(document).ready(function () {
//     pgutAddPatterns();
//     console.log('i');
// });

// front :
jQuery(window).load(function () {
    pgutAddPatterns();
});

// changement dans l'éditeur
jQuery(document).ready(function($) {
    if($('body.wp-admin').length < 1)
        return false;

    const { subscribe } = wp.data;

    // Surveiller les changements dans l'éditeur
    subscribe(function() {
        if(!wp)
            return false;
        const blocks = wp.data.select('core/block-editor').getBlocks();

        blocks.forEach(block => {
            if (block.name === 'core/group') {
                pgutRemovePatterns();
                pgutAddPatterns();
                //$(document).trigger('groupBlockChanged', [block]);
            }
        });
    });
});

function pgutAddPatterns() {
    let $pgut_groups__alignfull = jQuery('.wp-block-group.is-style-pattern-before, .wp-block-group.is-style-pattern-after, .wp-block-group.is-style-pattern-before-and-after');

    $pgut_groups__alignfull.each(function(){

        let $group = jQuery(this);
        let $group_prev = $group.prev();
        let $group_next = $group.next();

        // récupératio nde la classe de couleur pour l'adapter aux patterns
        let $classes = $group.attr('class').split(' ');
        let $color = $classes.find(c => c.includes('-background-color'));
        if( $color )
            $color = $color.replace('-background-color', '-color');
        else
            $color = 'has-neutral-1-color';

        // gestion du pattern before
        if( $group_prev !== false && (  $group.is('.is-style-pattern-before:not(.pgut-pattern__group__before__is-loaded)') ||  $group.is('.is-style-pattern-before-and-after:not(.pgut-pattern__group__before__is-loaded)') )){
            // ajout du pattern
            let $pgut_pattern_group_before = jQuery('<div class="is-layout-flow alignfull pgut-pattern__group pgut-pattern__group__before pgut-pattern__group__align-full pgut-pattern__group__align-full__before">' + $svg_pgut_pattern_group_before + '</div>').insertBefore($group);
            $group.addClass('pgut-pattern__group__before__is-loaded');
            // accord de la couleur du groupe et du pattern
            $pgut_pattern_group_before.addClass($color);

            // raccord couleur avec le group d'après si /1 il est étendu et 2/ a un background

            if( $group_prev.is('.wp-block-group.has-background') ){
                let $classes_prev = $group_prev.attr('class').split(' ');
                let $background_prev = $classes_prev.find(c => c.includes('-background-color'));
                $pgut_pattern_group_before.addClass('has-background').addClass($background_prev);

            }
        }

        // gestion du pattern after
        if( $svg_pgut_pattern_group_after !== false && ( $group.is('.is-style-pattern-after:not(.pgut-pattern__group__after__is-loaded)') || $group.is('.is-style-pattern-before-and-after:not(.pgut-pattern__group__after__is-loaded)')) ){
            // ajout du pattern
            let $pgut_pattern_group_after = jQuery('<div class="is-layout-flow alignfull pgut-pattern__group pgut-pattern__group__after pgut-pattern__group__align-full pgut-pattern__group__align-full__after">' + $svg_pgut_pattern_group_after + '</div>').insertAfter($group);
            $group.addClass('pgut-pattern__group__after__is-loaded');

            // accord de la couleur du groupe et du pattern
            $pgut_pattern_group_after.addClass($color);

            // raccord couleur avec le group d'après si /1 il est étendu et 2/ a un background
            if( $group_next.is('.wp-block-group.alignfull.has-background') ){
                let $classes_next = $group_next.attr('class').split(' ');
                let $background_next = $classes_next.find(c => c.includes('-background-color'));
                $pgut_pattern_group_after.addClass('has-background').addClass($background_next);

            }
        }

    });
}
function pgutRemovePatterns() {
    jQuery('.pgut-pattern__group__before__is-loaded').removeClass('pgut-pattern__group__before__is-loaded');
    jQuery('.pgut-pattern__group__after__is-loaded').removeClass('pgut-pattern__group__after__is-loaded');

    let $pgut_pattern_group_before = jQuery('.pgut-pattern__group__before');
    $pgut_pattern_group_before.remove();

    let $pgut_pattern_group_after = jQuery('.pgut-pattern__group__after');
    $pgut_pattern_group_after.remove();
}
